import { bodyReq } from '../../utils/bodyRequest';
import { getNamespace } from '../../utils/storage';
import * as api from './LaboratoryApi';
import * as type from './LaboratoryType';

/**
 * @param {{loading: boolean,error: boolean,updating: boolean}} params
 */

/**
 *
 * @param {{loading: boolean, error:boolean, initialized: boolean }} state
 */
export const setFetchingState = (state) => ({
    type: type.SET_FETCHING_STATE,
    payload: state
});

export const setLaboratoryFactorsList = (state) => ({
    type: type.SET_LABORATORY_FACTOR_LIST,
    payload: state
});

/**
 * @param {{issued_datetime: number,report_datetime: number,images: {id: number,url:string}[]}[]} labImages
 */
export const setLaboratoryImages = (labImages) => ({
    type: type.SET_LABORATORY_IMAGES_GROUPS,
    payload: labImages
});

export const setLaboratoryTests = (labTests) => ({
    type: type.SET_LABORATORY_TEST_GROUPS,
    payload: labTests
});

export const getLaboratoryFactors =
    ({ offset = 0, limit = 100, search }, onResponse, service = api.getLaboratoryFactors) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service({ offset, limit, search, namespace })
            .then(({ data }) => {
                onResponse && onResponse(data);
                dispatch(setLaboratoryFactorsList(data.factors));
            })
            .catch((error) => {
                onResponse && onResponse(error);
            });
    };

export const getLaboratoryTests =
    (patientId, offset, limit, service = api.getLaboratoryTest) =>
    async (dispatch) => {
        dispatch(
            setFetchingState({
                loading: true
            })
        );
        const namespace = getNamespace();
        return await service(patientId, offset, limit, namespace)
            ?.then(({ data }) => {
                dispatch(setLaboratoryTests(data.lab_test_groups));
                dispatch(setLaboratoryImages(data.lab_test_images_group.results));
                dispatch(
                    setFetchingState({
                        loading: false,
                        error: false,
                        initialized: true
                    })
                );
            })
            .catch(() => {
                dispatch(
                    setFetchingState({
                        loading: false,
                        error: true
                    })
                );
            });
    };

export const deleteLaboratoryResult =
    (resultId, tableId, service = api.deleteLaboratoryResult) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(resultId, namespace).then(() => {
            dispatch({
                type: type.DELETE_LABORATORY_TEST,
                payload: resultId,
                tableId
            });
            // dispatch(setLaboratoryTests(laboratoryTestGroups.filter((v) => v.id !== resultId)));
            // onResult && onResult();
        });

        // .catch(() => {
        //     onResult && onResult();
        // });
    };

/**
 * @param {{patient_id: number,issued_datetime: string,report_datetime: string,values: {factor_id: number,value: string}[]}} params
 */
export const createLaboratoryResult =
    ({ data: params, doOnSuccess }, service = api.createLaboratoryResult) =>
    async (dispatch) => {
        const body = bodyReq(params);
        return await service(body).then(({ data }) => {
            dispatch(getLaboratoryTests(params.patient_id));
            doOnSuccess && doOnSuccess(data);
        });
    };

/**
 * @typedef {{factor_id: number,value: string}} Value
 * @typedef {{patient_id: number, issued_datetime: string, report_datetime: string, values: Value[]}} Data
 * @param {{data: Data, result_id: number,group_id: number,patient_id}} param
 */

export const editLaboratoryResult =
    (
        { data: params, result_id, group_id, patient_id, doOnSuccess },
        service = api.editLaboratoryResult
    ) =>
    async (dispatch, getState) => {
        const laboratoryTestGroups = getState()?.laboratory?.laboratoryTestGroups;
        const body = bodyReq(params);
        return await service(result_id, body).then(({ data }) => {
            dispatch(
                setLaboratoryTests(
                    laboratoryTestGroups?.map((v) =>
                        v.id === group_id
                            ? {
                                  ...v,
                                  results: v.results.map((r) => (r.id === result_id ? data : r))
                              }
                            : v
                    )
                )
            );
            dispatch(getLaboratoryTests(patient_id));
            doOnSuccess && doOnSuccess();
        });
    };

/**
 * @param {{issued_datetime: string,report_datetime: string,patient_id: number,image: string,onDone: (data) => void, onError: (error) => void}} data
 */
export const createLaboratoryTestImageResult =
    ({ onDone, onError, ...data }, service = api.createLaboratoryImageResult) =>
    async (dispatch, getStore) => {
        const laboratoryTestImagesResults = getStore()?.laboratory?.laboratoryTestImagesResults;
        const namespace = getNamespace();
        const body = new FormData();
        body.append('patient_id', data.patient_id);
        body.append('image', data.image);
        body.append('issued_datetime', data.issued_datetime);
        body.append('namespace', namespace);
        data.report_datetime && body.append('report_datetime', data.report_datetime);
        return await service(body)
            .then(({ data }) => {
                dispatch(setLaboratoryImages([...laboratoryTestImagesResults, data]));
                onDone && onDone(data);
            })
            .catch((error) => {
                onError && onError(error);
            });
    };

export const addImageToLaboratoryTestImageResult =
    ({ imageResultId, image, onDone, onError }, service = api.addImageToLaboratoryImageResult) =>
    async (dispatch, getStore) => {
        const laboratoryTestImagesResults = getStore()?.laboratory?.laboratoryTestImagesResults;
        const namespace = getNamespace();
        const body = new FormData();
        body.append('image', image);
        body.append('namespace', namespace);

        return await service(imageResultId, body)
            .then(({ data }) => {
                dispatch(
                    setLaboratoryImages(
                        laboratoryTestImagesResults?.map((v) => (v.id === data.id ? data : v))
                    )
                );
                onDone && onDone(data);
            })
            .catch((error) => {
                onError && onError(error);
            });
    };

export const deleteImageFromLaboratoryTestImageResult =
    (imageResultId, imageId, onResult, service = api.deleteImageFromLaboratoryImageResult) =>
    async (dispatch, getStore) => {
        const laboratoryTestImagesResults = getStore()?.laboratory?.laboratoryTestImagesResults;
        const namespace = getNamespace();
        return await service(imageResultId, imageId, namespace)
            .then(({ data }) => {
                dispatch(
                    setLaboratoryImages(
                        laboratoryTestImagesResults?.map((v) => (v.id === data.id ? data : v))
                    )
                );
                onResult && onResult();
            })
            .catch(() => {
                onResult && onResult();
            });
    };
